import React, { useState } from "react";
import { Button, Container, Row, Col, Modal } from "reactstrap";
import ProfilePageTopContent from "../../Profile/CompanyProfilePage/ProfilePageTopContent";
import { profileService } from "../../../_services";
import CompanyInfo from "../../Profile/CompanyProfilePage/CompanyInfo";
import ContactInfo from "../../Profile/CompanyProfilePage/ContactInfo";
import AddressDetails from "../../Profile/CompanyProfilePage/AddressDetails";
import Industries from "../../Profile/CompanyProfilePage/Industries";
import PulseLoader from "react-spinners/PulseLoader";
import Documents from "../../Profile/CompanyProfilePage/Documents";
import SpecialNeeds from "components/Profile/CompanyProfilePage/SpecialNeeds";
import { useTranslation } from "react-i18next";
import queryString from "query-string";
import SecondaryContacts from "../../Profile/CompanyProfilePage/SecondaryContacts";
import { AccountTypes } from "../../../_helpers";
import { LanguageContext } from "_context";
import { useContext } from "react";
function SearchDetails({ history, match, location }) {
  const id = match.params.userId;
  const state = location.state;
  const user = profileService.userValue;
  const path = match;
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [secondaryUsers, setSecondaryUsers] = useState([]);
  const [isDisabled, setIsDisabled] = useState([]);
  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");
  const [currentLan, setCurrentLan] = useContext(LanguageContext);
  const userProfileID = location.pathname.split("/")[4];

  const { t, i18n } = useTranslation();
  const rtl = i18n.dir() == "rtl";
  const parsed = queryString.parse(location.search);
  const fetchData = async () => {
    setLoading(true);
    await profileService
      .GetProfileById(id, false, null, user.profile.userId, currentLan)
      .then((profile) => {
        setInfo(profile);
      });
    await profileService
      .GetSecondaryUsersAsync(userProfileID)
      .then((secUsers) => {
        setSecondaryUsers(secUsers);
        const disabledArr = [];
        for (const user in secUsers) {
          disabledArr[user] = secUsers[user].disabled;
        }
        setIsDisabled(disabledArr);
      });
    setLoading(false);
  };
  React.useEffect(() => {
    fetchData();
    document.body.classList.add("profile-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    document.body.style = "background-color: #ffffff";
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("profile-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  console.log("searchDetails");

  if (loading) {
    return (
      <>
        <center
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            left: "50%",
            top: "50%",
          }}
        >
          <PulseLoader color="#0E6EB8" />
        </center>
      </>
    );
  }

  return (
    <>
      {" "}
      <>
        <Modal isOpen={error} style={rtl ? { textAlign: "right" } : {}}>
          <div
            className="modal-header text-center"
            style={{ margin: "0 auto" }}
          >
            <h5 className="modal-title">{t("error.alert")}</h5>
          </div>
          <div className="modal-body" style={{ margin: "0 auto" }}>
            <p>{message}</p>
          </div>
          <div className="modal-footer">
            <Button
              color="danger"
              type="button"
              style={
                rtl
                  ? { margin: "auto", textAlign: "right" }
                  : { margin: "auto" }
              }
              onClick={() => {
                setError(false);
                setMessage("");
              }}
            >
              {t("close.button")}
            </Button>
          </div>
        </Modal>
      </>
      <div className="">
        {info && (
          <>
            <ProfilePageTopContent
              props={info}
              history={history}
              location={location}
              rtl={rtl}
            />
            <div className={rtl ? "section text-right" : "section"}>
              <Container>
                <div className="button-container">
                  {parsed.fromBadges == "true" ? (
                    <></>
                  ) : (
                    <Button
                      className="btn"
                      color="primary"
                      size="lg"
                      onClick={() => {
                        parsed !== null &&
                        parsed !== undefined &&
                        parsed.fromSeen === "true"
                          ? path !== null &&
                            path !== undefined &&
                            path.path ===
                              "/seeker/search-provider/search-details/:userId"
                            ? history.push(`/seeker/seenSP`)
                            : history.push(`/partner/seenSP`)
                          : parsed !== null &&
                            parsed !== undefined &&
                            parsed.showChat === "false"
                          ? history.push(`/admin/users`)
                          : state != undefined && state.fromPartner === true
                          ? history.push({
                              pathname: `/partner/search-provider/`,
                              state: { fromPartner: true },
                            })
                          : history.push(`/seeker/search-provider`);
                      }}
                    >
                      {t("backToList")}
                    </Button>
                  )}
                </div>
              </Container>
            </div>
            <Container style={{ marginTop: "-50px" }}>
              <Row>
                <Col md="6">
                  <CompanyInfo props={info} />
                  <AddressDetails props={info} />
                  <Industries props={info} />
                </Col>
                <Col md="6">
                  <Row>
                    <ContactInfo props={info} />
                  </Row>
                  {parsed.fromAdmin && (
                    <Row>
                      <SecondaryContacts
                        props={info}
                        secondaryUsers={secondaryUsers}
                        setSecondaryUsers={setSecondaryUsers}
                        isAdmin
                        userProfileID={userProfileID}
                        setError={setError}
                        setMessage={setMessage}
                        isDisabled={isDisabled}
                        setIsDisabled={setIsDisabled}
                      />
                    </Row>
                  )}
                  {/* {user.profileTypeView.profileTypeDescription ===
                  AccountTypes.Seeker ? (
                    <Row>
                      <PrivacyDetails props={info} />
                    </Row>
                  ) : null} */}

                  <Row>
                    <Documents props={info} />
                  </Row>
                  {info != null &&
                  info.profileTypeView != null &&
                  info.profileTypeView.profileTypeDescription ===
                    AccountTypes.Provider ? (
                    <Row>
                      <SpecialNeeds props={info} />
                    </Row>
                  ) : (
                    <></>
                  )}
                </Col>
              </Row>
            </Container>
            {/* <DefaultFooter /> */}
          </>
        )}
      </div>
    </>
  );
}

export default SearchDetails;
